import { render, staticRenderFns } from "./LegalBasis.vue?vue&type=template&id=4a3fec1f&"
import script from "./LegalBasis.vue?vue&type=script&lang=js&"
export * from "./LegalBasis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports